import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import {
  Card,
  CardBody,
  Button,
  ButtonGroup,
  Form,
  CustomInput,
  FormGroup,
  Label,
  Modal,
  ModalBody, ModalFooter,
  ModalHeader,
  Input
} from 'reactstrap';

import { Separator } from '../../../../../components/common/CustomBootstrap';
import CustomSelectInput from '../../../../../components/common/CustomSelectInput';
import Tooltip from './Tooltip';

export default function IntegrationInfo({
  integration,  
  integrationProperties,
  allProperties,
  saveIntegration,
  membership
}) {
  const [ownTag, setOwnTag] = useState('');
  const [showselect, setshowselect] = useState(true);
  const [formatedProperties, setFormatedProperties] = useState([]);
  const [isEditing, setIsEditing] = useState(true);
  const [list, setList] = useState(integration.properties);
  const [name, setName] = useState('');
  const [isAivaHide, setIsAivaHide] = useState(integration.isaivaHide || false);
  const [memberShipTags, setMembershipTags] = useState([]);
  const [isShowMembership, setIsShowMembership] = useState(integration.isMemberShip === undefined?false:integration.isMemberShip);
  const [allVouchers, setAllVouchers] = useState(integration.allVouchers === undefined?false:integration.allVouchers);
  const [selectedMemberShipTags, setSelectedMembershipTags] = useState([]);
  const [addMemberShipModal, setAddMemberShipModal] = useState(false);
  const [integrationTags, setIntegrationTags] = useState([]);  
  useEffect(() => {
    const result = integrationProperties.map(id => {
      return allProperties.find(elem => elem.id === id);
    });
    setFormatedProperties(result);    
    let membershipOptions = [];
    let selectedMemberShip = [];
    if (integration.membershipTags !== undefined) {
      integration.membershipTags.map((item) => {
        if (membershipOptions.filter(m => m.value == item).length === 0) {
          membershipOptions.push({
            label: item,
            value: item,
            key: item
          });
          selectedMemberShip.push({
            label: item,
            value: item,
            key: item
          });
        }
      });
    }    
    selectedMemberShip = selectedMemberShip.filter((f) => f.value !== 'Add own tag');
    setSelectedMembershipTags(selectedMemberShip);  
    if (membership !== undefined && membership !== null && membership.length > 0) {
      membership.map((m) => {
        if (membershipOptions.filter(f => m == f.value).length === 0) membershipOptions.push({
          label: m,
          value: m,
          key: m
        });
      })
    }     
   membershipOptions.push({
      label: 'Add membership',
      value: 'Add membership',
      key: 'Add membership',
    });            
    setMembershipTags(membershipOptions);

  }, [integrationProperties, allProperties]);

  const AddMemberShipTags = (val) => {    
    let tag = memberShipTags;
    tag.push({ label: val, value: val, key: val });
    let tag1 = selectedMemberShipTags;
    tag1.push({ label: val, value: val, key: val });
    setMembershipTags(tag);
    setSelectedMembershipTags(tag1);
    setAddMemberShipModal(!addMemberShipModal);
    setOwnTag('');
    const tagsArr = tag1.map((elem) => elem.value);
    setIntegrationTags(tagsArr);
    setshowselect(true);
  }

  const handleMemberShipTags = (selectedTags) => {
  
    if (selectedTags.filter((elem) => elem.value === 'Add membership').length === 0) {
      setSelectedMembershipTags(selectedTags);
      const tagsArr = selectedTags.map((elem) => elem.value);
      setIntegrationTags(tagsArr);
    } else {
      setshowselect(false);
      setAddMemberShipModal(!addMemberShipModal);
    }
  };


  const handleCheckChange = (id) => {
    let arr = [...list];      
    if (arr.filter(f=>f == id).length > 0)
      arr = arr.filter(f=>f !== id);    
    else
      arr.push(id);          
    setList(arr);

  };


  const handleSave = () => {
    saveIntegration({ list, name, isAivaHide,isShowMembership,selectedMemberShipTags, allVouchers });        
    setIsEditing(!isEditing);
  };

  const handleNameChange = e => {
    setName(e.target.value);
  };

  const Show = () => {
    return (
      <CardBody>
        <div className="text-center">
          <h6>
            Select Businesses
          </h6>
          <Separator className="mb-3" />
          <h1>{integration ? integration.name : null}</h1>
          <div>
            <h6>Group</h6>
            <div className="mb-2">
              <span className="text-muted">
                ({integration ? integration.groupId : null})
              </span>
            </div>
          </div>
          <div className='mb-2'>
            <h6>Select Businesses to include in this Voucher Store</h6>
            <div className="mb-2">
              {formatedProperties
                ? formatedProperties.map((elem, index) => {
                  return (
                    <div key={index} className="mb-2">
                      <b>{elem ? elem.name : null}</b>{' '}
                      <span className="text-muted">
                        ({elem ? elem.id : null})
                      </span>
                    </div>
                  );
                })
                : null}
            </div>

          </div>
          <Button
            size="xs"
            color="success"
            outline
            style={{ marginTop: '30px', display: 'inline-block' }}
            onClick={() => setIsEditing(!isEditing)}
          >
            Edit
          </Button>
        </div>
      </CardBody>
    );
  };
  const handleSelectAll=(e)=>{    
    if(allProperties.length === list.length)
    { setList([]);
    } else{
      setList(allProperties.map(m=> m.id));
    }
  }

  const Edit = () => {
    return (
      <CardBody>
        <div className="text-center">
          <h6>
            Integration Information{' '}
            <Tooltip
              item={{
                text: '?',
                body:
                  'Integration allows you to select the chat widget appearance, choose properties, and generate code to publish your digital assistant on your website.',
              }}
              id={integration.id}
            />
          </h6>
          <Separator className="mb-3" />
          <div className="mb-1">
            <h6>Integration Name</h6>
            <input
              style={{
                width: '45%',
                border:'1px solid black',
                padding: '5px',
                fontSize: '18px',
                textAlign: 'center',
              }}
              name="name"
              defaultValue={integration.name}
              onChange={handleNameChange}
            />
          </div>
          <div>
            <h6>Group</h6>
            <div className="mb-2">
              <span className="text-muted">
                ({integration ? integration.groupId : null})
              </span>
            </div>
          </div>
          <div>
            <h6>Select Businesses to include in this Voucher Store</h6>            
            <Form>
            <FormGroup className="mt-3">
                <div className='integration-property text-start'>                    
                  <div className='row' style={{padding:'0% 15%', textAlign:'left'}}>
                    <div className='col-md-6'>
                     <CustomInput
                        key={"selectAll"}
                        type="checkbox"
                        id={"selectAll"}  
                        label="Select All" 
                        value={allProperties.length === list.length ? true : false}                    
                        checked={allProperties.length === list.length ? true : false}
                        onChange={(e)=>handleSelectAll(e)}
                      />
                    </div>
                  {allProperties !== undefined && allProperties.map((p, index) => {
                    return (
                      <div className='col-md-6'>
                      <CustomInput
                        key={p.id}
                        type="checkbox"
                        checked={(list.length>0 && list.filter(f=>f===p.id).length >0) ?true:false}
                        id={index}
                        label={p.name}
                        value={p.id}
                        onChange={()=>handleCheckChange(p.id)}
                      />
                    </div>
                    );
                  })}
                </div>
              </div>
              </FormGroup>
            </Form>
          </div>
          <div className='mb-2'>
            <h6>Members Only</h6>
            <CustomInput
              type="checkbox"
              id="isMemberShip"
              checked={isShowMembership}
              name="isMemberShip"
              onChange={(e) => setIsShowMembership(e.target.checked)}
            />
          </div>
          <div>
          {isShowMembership === true && showselect===true &&
              <FormGroup>                
                <h6>Memberships</h6>
                <Select
                  components={{ Input: CustomSelectInput }}
                  className="react-select"
                  classNamePrefix="react-select"
                  isMulti={true}
                  name="form-field-name"
                  value={selectedMemberShipTags}
                  onChange={handleMemberShipTags}
                  options={memberShipTags}
                />
              </FormGroup>}
          </div>
          {integration.channel=="EmbedVoucher" &&
          <div className='mb-2'>
            <h6>All Vouchers</h6>
            <CustomInput
              type="checkbox"
              id="allVouchers"
              checked={allVouchers}
              name="allVouchers"
              onChange={(e) => setAllVouchers(e.target.checked)}
            />
          </div>}
          <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
            <Button color="primary" size="xs" onClick={handleSave}>
              Save
            </Button>
            <Button
              size="xs"
              color="dark"
              outline
              onClick={() => setIsEditing(!isEditing)}
            >
              Cancel
            </Button>
          </ButtonGroup>
        </div>
        <Modal isOpen={addMemberShipModal} toggle={() => { setshowselect(true); setAddMemberShipModal(!addMemberShipModal); }}>
          <ModalHeader toggle={() => setAddMemberShipModal(!addMemberShipModal)}>
            ADD OWN MEMBERSHIP
          </ModalHeader>
          <ModalBody>
            <div className='margin-0'>
              <Input
                type="text"
                name="ownTag"
                value={ownTag}
                onChange={(e) => { setOwnTag(e.target.value) }}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={() => AddMemberShipTags(ownTag)}>
              Add
            </Button>
            <Button color="secondary" onClick={() => { setshowselect(true); setAddMemberShipModal(!addMemberShipModal); }}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </CardBody>      
    );
  };

  return <Card className="mb-4">{isEditing ? Edit() : Edit()}</Card>;
}
